// receivableDetail.service.ts

import receivableDetailApi from "../api/receivableDetail.api";

const ReceivableDetailService = {
  /**
   * 📌 Obtener detalle de cuenta por cobrar
   * GET /api/receivables/details/{id}
   */
  getById: async (id: number) => {
    const response = await receivableDetailApi.fetchCustom(`/${id}`);

    return response.data;
  },
};

export default ReceivableDetailService;